import { ref } from "vue";

export const NAV_CONTEXT_STORAGE_KEY = "miridar-nav-context";
export const NCRM_CONTEXT_PATHS = ["/ncrm", "/ai-workspace"];

const HR_CONTEXT_PATH_PATTERN = /^\/(hr-dashboard|Recrutare|RecrutareDetails|Candidati|UploadCV|candidates)(\/|$)/i;
export const isPathInHrContext = (path = "") => HR_CONTEXT_PATH_PATTERN.test(path);

export const isPathInNcrmContext = (path = "") =>
  NCRM_CONTEXT_PATHS.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));

// Apelat la logout (clearAuthStorage): contextul meniului nu trebuie moștenit de alt cont din același tab.
export const clearNavContext = (storage = globalThis.sessionStorage) => storage?.removeItem?.(NAV_CONTEXT_STORAGE_KEY);

export const useNavigationDrawerContext = (storage = globalThis.sessionStorage) => {
  const navContext = ref(storage?.getItem?.(NAV_CONTEXT_STORAGE_KEY) || "");
  const writeContext = (value) => {
    navContext.value = value;
    if (!storage) return;
    if (value) storage.setItem(NAV_CONTEXT_STORAGE_KEY, value);
    else storage.removeItem(NAV_CONTEXT_STORAGE_KEY);
  };
  const rememberNavContextForPath = (path, { preserveShared = false } = {}) => {
    if (isPathInNcrmContext(path)) {
      writeContext("crm");
      return;
    }
    if (isPathInHrContext(path)) {
      writeContext("hr");
      return;
    }
    // `/me` e pagină comună: păstrăm numai contextul CRM (un context `hr` nu trebuie să treacă prin `/me`).
    if (preserveShared && path === "/me" && navContext.value === "crm") return;
    // `/users` e pagină comună: dacă utilizatorul vine din HR, meniul HR rămâne în drawer.
    if (preserveShared && path === "/users" && navContext.value === "hr") return;
    writeContext("");
  };
  const isNcrmContextRoute = (path = "") =>
    isPathInNcrmContext(path) || (path === "/me" && navContext.value === "crm");
  const isHrContextRoute = (path = "") =>
    isPathInHrContext(path) || (path === "/users" && navContext.value === "hr");
  return { navContext, rememberNavContextForPath, isNcrmContextRoute, isHrContextRoute };
};
